import { Router } from '@angular/router';

export function handleInterceptedPhxLinkHref(href: string, router: Router) {
    if (!href) {
        return false;
    }

    // if you are still here, the router will take over and do the navigation
    if (href?.startsWith('#')) {
        // only fragment, so go to named anchor or element with the given id
        router.navigate([], { fragment: href.substring(1) });
    } else if (href?.startsWith('(')) {
        // we just want to open an aux/child route relative to the current route
        router.navigateByUrl(location.pathname + href);
    } else {
        router.navigateByUrl(href);
    }
}
